import { sel } from "../../academy/selectors";
import { TutorialDefinition } from "../types";

/**
 * Academy lesson: policy checks. Started from the lesson page in a new tab;
 * never auto-started. Runs on the officer's own reports: the first step asks
 * them to open one. Steps that need a policy suggestion only appear for
 * departments with documents, so the tour points at what exists and never
 * clicks anything that changes a report.
 */
const tour: TutorialDefinition = {
  id: "policy-check-suggestions",
  version: "1.0.0",
  releasedAt: "2026-10-29T00:00:00.000Z",
  category: "onboarding",
  title: "Policy checks",
  description: "Find the policy items in Suggestions and open the section they cite.",
  triggerRoute: /^\/cases(\/.*)?$/,
  startRoute: "/cases",
  lessonId: "policy-check-suggestions",
  autoStart: false,
  steps: [
    {
      target: sel("caseListItem"),
      title: "Open a report",
      content: "Click a report that has a draft. A use of force or arrest report is the best fit, since policy covers those most.",
      disableBeacon: true,
      placement: "right",
      advanceOn: { selector: sel("caseListItem"), event: "click" },
      hint: "Open a report to continue",
      spotlightClicks: true,
    },
    {
      target: sel("editorNarrative"),
      waitFor: sel("editorNarrative"),
      title: "Citations and placeholders",
      content:
        "Look for text like (Title § 300.3 - Use of Force). That is the policy section the draft was written against. A highlighted placeholder that ends in \"required by Policy\" is a detail that policy asks for and the recording did not give.",
      disableBeacon: true,
      placement: "right",
    },
    {
      target: sel("policyBadge"),
      waitFor: sel("policyBadge"),
      waitTimeoutMs: 6000,
      title: "The source badge",
      content:
        "A suggestion from the policy check carries the policy and section underneath it. Click the badge to read that section in the sidebar. If you see no badge, this report has no policy check items.",
      disableBeacon: true,
      placement: "left",
    },
    {
      target: sel("addToReportButton"),
      waitFor: sel("addToReportButton"),
      title: "Address Suggestions",
      content: "To answer several items at once, record or upload audio here. Then click Re-evaluate to run the policy check again.",
      disableBeacon: true,
      placement: "left",
    },
    {
      target: sel("reEvaluate"),
      waitFor: sel("reEvaluate"),
      title: "Re-evaluate",
      content: "After you fill a placeholder or add a detail, Re-evaluate checks the report against the policy again.",
      disableBeacon: true,
      placement: "left",
    },
  ],
};

export default tour;
